var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayerX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(12.9999 13)",
    fill: "#735CF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1652 17.4604C29.5564 17.0706 30.1904 17.0712 30.5802 17.4624C30.9698 17.8535 30.9682 18.4867 30.5773 18.8765L27.5486 21.8937C26.3716 23.0662 26.3716 24.9719 27.5486 26.1444L30.5773 29.1616L30.6456 29.2368C30.9669 29.629 30.9456 30.2088 30.5802 30.5757C30.1904 30.9669 29.5564 30.9674 29.1652 30.5776L26.117 27.5399C24.9462 26.373 23.0522 26.3731 21.8814 27.5401L18.8341 30.5776C18.443 30.9673 17.8099 30.9666 17.42 30.5757C17.0303 30.1845 17.0311 29.5515 17.422 29.1616L20.4503 26.1442C21.627 24.9717 21.627 23.0663 20.4503 21.8939L17.422 18.8765L17.3536 18.8013C17.0324 18.4091 17.0545 17.8292 17.42 17.4624C17.7855 17.0959 18.3647 17.0717 18.7579 17.3911L18.8341 17.4604L21.8816 20.4976C23.0523 21.6643 24.9461 21.6644 26.1168 20.4978L29.1652 17.4604Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1282 23.9986C19.1282 24.5509 18.6805 24.9986 18.1282 24.9986C17.5759 24.9986 17.1282 24.5509 17.1282 23.9986C17.1282 23.4463 17.5759 22.9986 18.1282 22.9986C18.6805 22.9986 19.1282 23.4463 19.1282 23.9986Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8714 23.9977C30.8714 24.5499 30.4237 24.9977 29.8714 24.9977C29.3191 24.9977 28.8714 24.5499 28.8714 23.9977C28.8714 23.4454 29.3191 22.9977 29.8714 22.9977C30.4237 22.9977 30.8714 23.4454 30.8714 23.9977Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 28.8702C24.5521 28.8702 24.9998 29.318 24.9998 29.8702C24.9998 30.4225 24.5521 30.8702 23.9998 30.8702C23.4475 30.8702 22.9998 30.4225 22.9998 29.8702C22.9998 29.318 23.4475 28.8702 23.9998 28.8702Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 17.127C24.5521 17.127 24.9998 17.5747 24.9998 18.127C24.9998 18.6792 24.5521 19.127 23.9998 19.127C23.4475 19.127 22.9998 18.6792 22.9998 18.127C22.9998 17.5747 23.4475 17.127 23.9998 17.127Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerX);
export default __webpack_public_path__ + "static/media/LayerX.16ce8041a870fc3dfb985375a1b53cb5.svg";
export { ForwardRef as ReactComponent };